import { gql } from '@apollo/client';

export const GET_ALL_BATCH_ADJUSTMENT_TASKS = gql`
    query GetAllBatchAdjustmentTasks {
        getAllBatchAdjustmentTasks {
            id
            submitterId
            submitterName
            detailCount
            status
            successCount
            failCount
            resultFileUrl
            createdAt
            updatedAt
        }
    }
`;

export interface BatchAdjustmentTaskResponse {
    getAllBatchAdjustmentTasks: BatchAdjustmentTaskType[];
}

export interface BatchAdjustmentTaskType {
    id: number;
    submitterId: number;
    submitterName: string;
    detailCount: number;
    status: string;
    successCount: number;
    failCount: number;
    resultFileUrl?: string;
    createdAt: string;
    updatedAt: string;
}
